module.exports = __webpack_public_path__ + "static/media/universities-icon-1.07fd9662.svg";